export default "/signup/_next/static/chunks/fonts/inter-v3-latin-regular-602c535ab11ca196a2d316fe33c5c769.woff2";